module.exports = __webpack_public_path__ + "static/media/3.Drill Machine.0b75ef3a.jpg";